import {setLoading, useMaterialUIController} from "../../Context/mui";
import DashboardNavbar from "../../Components/Navbars/DashboardNavbar";
import DashboardLayout from "../../Components/LayoutContainers/DashboardLayout";
import MDTableCell from "../../Components/MDTable/MDTableCell";
import {Table} from "reactstrap";
import MDBox from "../../Components/MDBox";
import Paper from "@mui/material/Paper";
import MDTableRow from "../../Components/MDTable/MDTableRow";
import React, {forwardRef, useEffect, useState} from "react";
import MDButton from "../../Components/MDButton";
import {
    Autocomplete,
    Grid, Slide,
    TableBody,
    TableContainer,
    TableHead,
    TablePagination,
    TableRow,
    TextField
} from "@mui/material";
import MDTypography from "../../Components/MDTypography";
import MDInput from "../../Components/MDInput";
import MDSelect from "../../Components/MDSelect";
import MDDate from "../../Components/MDDate";
import {ErrorToaast} from "../../utils/toast/Toast";
import {v4 as uuid} from "uuid";
import Tooltip from "@mui/material/Tooltip";
import IconButton from "@mui/material/IconButton";
import Cookies from "js-cookie";
import {NoskheModel} from "../../Api/Model/NoskheModel";
import {ReactComponent as Moshahede} from '../../Asset/images/icons/lets-icons_view.svg'
import DialogTitle from "@mui/material/DialogTitle";
import DialogContent from "@mui/material/DialogContent";
import DialogContentText from "@mui/material/DialogContentText";
import DialogActions from "@mui/material/DialogActions";
import Dialog from "@mui/material/Dialog";
import {CurrentUser} from "../../utils/Hooks/currentUser";
import {UserModel} from "../../Api/Model/UserModel";

const Transition = forwardRef(function Transition(props, ref) {
    return <Slide direction="up" ref={ref} {...props} />;
});

export default function NoskhePage() {
    const [pageNumber, setPageNumber] = useState(1);
    const [pageSize, setPageSize] = useState(10);
    const [counter, setCounter] = useState(0)
    const [controller, dispatch] = useMaterialUIController();
    const [studentShowMedalDialog, setStudentShowMedalDialog] = useState({open: false, model: null});

    const {loading} = controller;
    let Api = new NoskheModel(Cookies.get("cst") ?? "");
    let UserApi = new UserModel(Cookies.get("cst") ?? "");

    const [rows, setRows] = useState({
        content: [],
        pageSize: 0,
        totalPages: 0,
    });


    useEffect(() => {
        setLoading(dispatch, true);
        Api
            .getAllWithPaginate(CurrentUser()?.user.id, pageNumber, pageSize)
            .then((r) => {
                setRows(r.data.data);
            })
            .then(() => {
                UserApi
                    .GetMedal(CurrentUser()?.user.id)
                    .then((r) => {
                        setStudentShowMedalDialog({model: r.data.data, open: true})
                    })
                    .catch(() => {
                        ErrorToaast("خطا در دریافت اطلاعات")
                    });
            })
            .catch(r => {
                if (r?.status == 404) {
                    setLoading(dispatch, false)

                    return
                }
                ErrorToaast("دریافت اطلاعات با مشکل مواجه شد")
                setLoading(dispatch, false)

            })
            .finally(() => {
                setLoading(dispatch, false);
            });


    }, [pageNumber, pageSize, counter]);
    const handleChangePage = (event, newPage) => {
        setPageNumber(newPage + 1);
    };
    const handleChangeRowsPerPage = (
        event
    ) => {
        setPageSize(+event.target.value);
        setPageNumber(1);
    };

    function defaultLabelDisplayedRows({from, to, count}) {
        return `${from}–${to} از ${
            count !== -1 ? count : `بیشتر از ${to}`
        }`;
    }

    function handleClickOpen(msg) {
        setNoskhedialog({msg, open: true})

    }

    function handleCloseNoskhe() {
        setNoskhedialog({msg: null, open: false})

    }

    return (
        <DashboardLayout>
            <DashboardNavbar name={"نسخه ها"}>
                نسخه ها
            </DashboardNavbar>
            <MDBox py={3} bgColor="#fff" p={2} mb={2} flex={1} borderRadius={2} style={{overflowX: "auto"}}>
                <Grid container justifyContent={"center"} wrap="nowrap">
 
                    <Grid container>
                        {studentShowMedalDialog?.model?.map((group, index) => (
                            <Grid item container key={index} spacing={2} mb={1}>
                                <Grid item xs={12}>
                                    <MDTypography variant="h6">{group.title}</MDTypography>
                                </Grid>
                                <Grid item xs={12}>
                                    <TableContainer component={Paper}>
                                        <Table>
                                            <TableHead>
                                                <TableRow>
                                                    <MDTableCell>نوع مدال</MDTableCell>
                                                    <MDTableCell>تاریخ اهدا</MDTableCell>
                                                </TableRow>
                                            </TableHead>
                                            <TableBody>
                                                {group.medals.map((medal, idx) => (
                                                    <TableRow key={idx}>
                                                        <MDTableCell>
                                                            {medal.medalType === 0 && "طلا"}
                                                            {medal.medalType === 1 && "نقره"}
                                                            {medal.medalType === 2 && "برنز"}
                                                            {medal.medalType === 3 && "ویژه"}
                                                        </MDTableCell>
                                                        <MDTableCell>
                                                            {new Date(medal.modified).toLocaleString('fa-IR')}
                                                        </MDTableCell>
                                                    </TableRow>
                                                ))}
                                            </TableBody>
                                        </Table>
                                    </TableContainer>
                                </Grid>
                            </Grid>
                        ))}
                    </Grid>
                </Grid>
            </MDBox>
            <MDBox py={3} bgColor={"#e8e8e8"} p={2} mb={2} borderRadius={20}>
                <MDTypography fontSize={14}>نسخه ها</MDTypography>

                <MDBox py={3} bgColor="#fff" p={2} mb={2} flex={1} borderRadius={2}>
                    <Grid container flexDirection={"column"}>
                        <Grid item sx={{width: "100%"}}>
                            <TableContainer component={Paper} sx={{width: "100%"}}>
                                <Table sx={{minWidth: 700}} aria-label="customized table">
                                    <TableHead>
                                        <TableRow>
                                            <MDTableCell align={"center"} style={{background: "#351F39"}}>
                                                نام پزشک
                                            </MDTableCell>

                                            <MDTableCell align={"center"} style={{background: "#351F39"}}>
                                                نام کاربری
                                            </MDTableCell>
                                            <MDTableCell align={"center"} style={{background: "#351F39"}}>
                                                تاریخ
                                            </MDTableCell>
                                            <MDTableCell align={"center"} style={{background: "#351F39"}}>
                                                عنوان نسخه
                                            </MDTableCell>
                                            <MDTableCell align={"center"} style={{background: "#351F39"}}>
                                                متن نسخه
                                            </MDTableCell>
                                        </TableRow>
                                    </TableHead>
                                    <TableBody>
                                        {rows?.content.length < 1 && (
                                            <MDTableRow
                                                sx={{
                                                    "&:last-child td, &:last-child th": {border: 0},
                                                }}
                                            >
                                                <MDTableCell colSpan={9} align="right">
                                                    بدون اطلاعات
                                                </MDTableCell>
                                            </MDTableRow>
                                        )}
                                        {rows?.content?.map((r) => {
                                            return (
                                                <MDTableRow
                                                    hover
                                                    role="checkbox"
                                                    tabIndex={-1}
                                                    key={uuid()}
                                                >
                                                    <MDTableCell align={"center"}>
                                                        {r?.doctorName + " " + r?.doctorLastName}
                                                    </MDTableCell>

                                                    <MDTableCell align={"center"}>
                                                        {r?.doctorUserName}
                                                    </MDTableCell>
                                                    <MDTableCell align={"center"}>
                                                        {new Date(r?.created).toLocaleString('fa-IR')}
                                                    </MDTableCell>

                                                    <MDTableCell align={"center"}>
                                                        {r?.title}
                                                    </MDTableCell>

                                                    <MDTableCell align={"center"} sx={{maxWidth: 250}}>
                                                        {r?.text}

                                                    </MDTableCell>

                                                </MDTableRow>


                                            );
                                        })}
                                    </TableBody>
                                </Table>
                            </TableContainer>
                            {rows?.content.length > 0 && (
                                <TablePagination
                                    rowsPerPageOptions={[10, 25, 100]}
                                    component="div"
                                    count={rows.totalPages}
                                    rowsPerPage={pageSize}
                                    page={pageNumber - 1}
                                    onPageChange={handleChangePage}
                                    onRowsPerPageChange={handleChangeRowsPerPage}
                                    labelDisplayedRows={defaultLabelDisplayedRows}
                                    labelRowsPerPage={<>تعداد در هر صفحه</>}
                                />
                            )}
                        </Grid>
                    </Grid>

                </MDBox>
            </MDBox>

        </DashboardLayout>
    )
}